<template>
  <b-modal
    id="xoa-group-thuoc-nguoi-dung"
    centered
    hide-footer
    size="md"
    header-class="border-bottom-none"
    footer-class="border-top-none"
    title="Bạn có chắc chắn xóa nhóm người dùng khỏi người dùng?"
  >
    <div class="d-flex justify-content-end">
      <base-button
        button="Xóa"
        class="btn btn-main"
        @click="xoaGroup()"
      >
        ĐỒNG Ý
      </base-button>
      <base-button
        button="Hủy"
        class="btn btn-line ml-2"
        @click="hideModal()"
      >
        {{ BO_QUA_BUTTON_LABEL }}
      </base-button>
    </div>
  </b-modal>
</template>
<script>
import { ROUTE_NAME, BO_QUA_BUTTON_LABEL } from "@/constants/constants";

export default {
  name: "XoaGroupThuocNguoiDungModal",
  props: {},
  data() {
    return {
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      ROUTE_NAME: ROUTE_NAME,
      emailSelected: 1,
      modalTitle: "",
      internalForm: {},
    };
  },
  watch: {
    form: {
      handler() {
        this.internalForm = this.form;
      },
      immediate: true,
    },
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("xoa-group-thuoc-nguoi-dung");
    },
    xoaGroup() {
      this.$bvModal.hide("xoa-group-thuoc-nguoi-dung");
      this.$emit("xoaDanhSachGroupThuocNguoiDung");
    },
  },
};
</script>

<style lang="scss">
#xoa-group-thuoc-nguoi-dung .modal-header {
  background: white;
  h5 {
    color: black;
  }

  .close {
    display: none;
  }
}
</style>
